import { RestClient } from "./restClient";

export class DeviceStateService {
    constructor(options) {
        this._options = options;
        this._restClient = new RestClient();
    }

    /**
     * Get all device state
     * @param {function} callback
     */
    getAll(callback) {
        const url = `/ecosystem/api/deviceState`;
        this._restClient.exec_get(url, callback);
    }

    /**
     * Create a device state
     * @param {Object} data
     */
    create(data, callback) {
        const url = `/ecosystem/api/deviceState`;
        const body = JSON.stringify(data);
        this._restClient.exec_post(url, body, callback);
    }

    /**
     * Update a device state
     * @param {String} deviceStateId
     */
    update(deviceStateId, data, callback) {
        const url = `/ecosystem/api/deviceState/${deviceStateId}`;
        const body = JSON.stringify(data);
        this._restClient.exec_put(url, body, callback);
    }

    /**
     * delete a device state
     * @param {String} deviceStateId
     */
    delete(deviceStateId, callback) {
        const url = `/ecosystem/api/deviceState/${deviceStateId}`;
        this._restClient.exec_delete(url, callback);
    }
}
